// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3pbXt","content":"Consent_content__1KoDk","footer":"Consent_footer__1nWwq"};